<div class="files-for-print" *ngIf="filesList.length">
  <h2 class="section__title" *ngIf="!hideTitle">Photos/Documents</h2>
  <div class="file-thumbnail" *ngFor="let file of filesList">
    <div class="file-wrapper">
      <img [src]="file.thumbnailUrl">
    </div>
  </div>
</div>
